import { render, staticRenderFns } from "./CorrecaoFiscalItemCarrinho.vue?vue&type=template&id=b9fb983c&scoped=true"
import script from "./CorrecaoFiscalItemCarrinho.vue?vue&type=script&lang=js"
export * from "./CorrecaoFiscalItemCarrinho.vue?vue&type=script&lang=js"
import style0 from "./CorrecaoFiscalItemCarrinho.vue?vue&type=style&index=0&id=b9fb983c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fb983c",
  null
  
)

export default component.exports